"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
function isExternalChatWebhook(object) {
    return checkExternalChatWebhook(object).fulfilled;
}
exports.isExternalChatWebhook = isExternalChatWebhook;
function checkExternalChatWebhook(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return __1.check(object, __1.hasString("eventName"), __1.hasString("url"), __1.hasMap("headers", __1.isString()).optional()).withOptions(options).explain();
}
exports.checkExternalChatWebhook = checkExternalChatWebhook;
//# sourceMappingURL=ExternalChatWebhook.js.map